import { TFunction } from 'i18next'

import { TooltipIconType } from '@wwt/ui/components/Tooltips'

interface TooltipType {
	tooltipIconType: TooltipIconType
	tooltipIconDescription: string
}

export type TooltipTypes = { [key: string]: TooltipType }

export const getTooltipTypes = (
	t: TFunction<'tooltips', undefined>,
	expiredAt: string
): TooltipTypes => ({
	warning: {
		tooltipIconType: TooltipIconType.WARNING,
		tooltipIconDescription: t('featureTypes.warning')
	},
	expired: {
		tooltipIconType: TooltipIconType.EXPIRED,
		tooltipIconDescription: t('featureTypes.expired', { expiredAt })
	},
	dollar: {
		tooltipIconType: TooltipIconType.DOLLAR,
		tooltipIconDescription: t('featureTypes.dollar')
	},
	expiring: {
		tooltipIconType: TooltipIconType.EXPIRING,
		tooltipIconDescription: t('featureTypes.expiring', { expiredAt })
	},
	smile: {
		tooltipIconType: TooltipIconType.SMILE,
		tooltipIconDescription: t('featureTypes.smile')
	},
	custom: {
		tooltipIconType: TooltipIconType.CUSTOM,
		tooltipIconDescription: t('featureTypes.custom')
	}
})
